<template>
	<div id="pixiView">
	</div>
</template>

<script>
	import * as PIXI from 'pixi.js';

	export default {
		name: 'Pixi',
		components: {},
		watch: {

		},
		data() {
			return {}
		},
		mounted() {
			let pixiApp = new PIXI.Application({
				width: 2000,
				height: 1000,
				backgroundColor: 0xF5F7F9FF,
				// resizeTo: window
			});

			//Add the canvas that Pixi automatically created for you to the HTML document
			document.getElementById("pixiView").append(pixiApp.view)
			
			// 创建一个容器来管理大批量的显示对象
			let objectsContainer = new PIXI.Container();
			pixiApp.stage.addChild(objectsContainer);

			//*******************拖动画布*******************
			let stageOriginalPos;
			let mouseDownPoint;
			let touchBlank = false;
			pixiApp.renderer.plugins.interaction.on(
				'pointerdown',
				(event) => {
					const globalPos = event.data.global;
					// 记录下stage原来的位置
					stageOriginalPos = [pixiApp.stage.position._x, pixiApp.stage.position._y];
					// 记录下mouse down的位置
					mouseDownPoint = [globalPos.x, globalPos.y];
					if (!event.target) {
						// 点到了画布的空白位置
						touchBlank = true;
					}
				}
			);

			pixiApp.renderer.plugins.interaction.on(
				'pointermove',
				(event) => {
					const globalPos = event.data.global;

					if (touchBlank) {
						// 拖拽画布
						const dx = globalPos.x - mouseDownPoint[0];
						const dy = globalPos.y - mouseDownPoint[1];
						pixiApp.stage.position.set(
							stageOriginalPos[0] + dx,
							stageOriginalPos[1] + dy
						);
					}
				}
			);

			pixiApp.renderer.plugins.interaction.on(
				'pointerup',
				(event) => {
					touchBlank = false;
				}
			);
			//*******************拖动画布*******************

			//*******************缩放画布*******************
			pixiApp.view.addEventListener('wheel', (event) => {
				event.stopPropagation();
				event.preventDefault();
				// 因为画布是充满视窗的，所以clientX等于mouse point在renderer上的x坐标
				const globalPos = [event.clientX, event.clientY];
				const delta = event.deltaY;
				const oldZoom = pixiApp.stage.scale.x;
				let newZoom = oldZoom * 0.999 ** delta;

				// const oldStageMatrix = app.stage.localTransform.clone();
				// const oldStagePos = oldStageMatrix.applyInverse(pointerGlobalPos);
				const oldStagePos = globalPos;
				const dx = oldStagePos[0] * oldZoom - oldStagePos[0] * newZoom;
				const dy = oldStagePos[1] * oldZoom - oldStagePos[1] * newZoom;

				pixiApp.stage.setTransform(
					pixiApp.stage.position.x + dx,
					pixiApp.stage.position.y + dy,
					newZoom,
					newZoom,
					0,
					0,
					0,
					0,
					0
				);

			});
			//*******************缩放画布*******************

			//*******************FPS*******************
			var g_Time=0;
			pixiApp.ticker.add((delta) => {
				var timeNow = (new Date()).getTime();
				var timeDiff = timeNow - g_Time;
				g_Time = timeNow;
				var fps = 1000 / timeDiff;
				this.mapFps = parseInt(fps)
			});
			//*******************FPS*******************
		}
	}
</script>

<style>
</style>